import { CubeTimeDimensionGranularity } from '../../../common/enum/cube-time-dimension-granularity.enum';
import { CubeRequestConfig } from '../../../common/interface/cube-request-config.interface';

export interface GetSelfAppCategoryChartAllTimeAverageRequestDto {
  params: {
    endDate: string;
    appCategoryId: string;
    granularity: CubeTimeDimensionGranularity;
  };
  config: CubeRequestConfig;
}
